import { Component, Input } from '@angular/core';
import RegisteredAction from 'src/app/model/registered-action';
import { StringHelper } from 'src/app/helpers/string-helper';
import DateHelper from 'src/app/helpers/date-helper';

@Component({
  selector: 'registered-action-display',
  templateUrl: './registered-action-display.component.html',
  styleUrls: ['./registered-action-display.component.scss'],
})
export class RegisteredActionDisplayComponent {
  @Input()
  inputRegisteredAction: RegisteredAction;

  printUser() {
    if (this.inputRegisteredAction.user == null) {
      return 'Geen gebruiker opgegeven';
    }
    return StringHelper.join(
      [
        this.inputRegisteredAction.user.firstName == null
          ? ''
          : this.inputRegisteredAction.user.firstName.toString(),
        this.inputRegisteredAction.user.lastName == null
          ? ''
          : this.inputRegisteredAction.user.lastName.toString(),
      ],
      ' '
    );
  }

  printDate() {
    if (this.inputRegisteredAction.date == null) {
      return 'Geen datum opgegeven';
    }
    return DateHelper.formatDateTime(this.inputRegisteredAction.date);
  }
}
